// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"42335713","323":"a91cb940","453":"99d8e610"}[chunkId] + ".chunk.js";
};